export default "__VITE_ASSET__DShe9wCr__"